import React from 'react';
import { Form, DatePicker } from 'antd';
import { filedNames } from '../../constants';

const { RangePicker } = DatePicker;

const DateTimeField = ({ form, initialValue }) => {
  const { getFieldDecorator } = form;

  return (
    <Form.Item label="Период" colon={false}>
      {getFieldDecorator(filedNames.dateTime, {
        initialValue,
        rules: [{ required: true, message: 'Укажите период', type: 'array' }],
      })(
        <RangePicker
          style={{ width: '100%' }}
          showTime={{ format: 'HH:mm' }}
          allowClear={false}
          format="DD.MM.YYYY HH:mm"
        />
      )}
    </Form.Item>
  );
};

export default DateTimeField;
